var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6022_419)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_6022_419",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0.400124,
    width: 16,
    height: 25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 0.400124,
    width: 16,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4.80012C6 4.1636 6.25286 3.55315 6.70294 3.10307C7.15303 2.65298 7.76348 2.40012 8.4 2.40012H15.6C16.2365 2.40012 16.847 2.65298 17.2971 3.10307C17.7471 3.55315 18 4.1636 18 4.80012V21.6001L12 18.6001L6 21.6001V4.80012Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.70294 3.10307L5.28873 1.68885L5.28873 1.68885L6.70294 3.10307ZM8.4 2.40012V0.400124V2.40012ZM15.6 2.40012V0.400124V2.40012ZM17.2971 3.10307L18.7113 1.68885V1.68885L17.2971 3.10307ZM18 21.6001L17.1056 23.389L20 24.8362V21.6001H18ZM12 18.6001L12.8944 16.8113L12 16.3641L11.1056 16.8113L12 18.6001ZM6 21.6001H4V24.8362L6.89443 23.389L6 21.6001ZM8 4.80012C8 4.69404 8.04214 4.5923 8.11716 4.51728L5.28873 1.68885C4.46357 2.51401 4 3.63317 4 4.80012H8ZM8.11716 4.51728C8.19217 4.44227 8.29391 4.40012 8.4 4.40012V0.400124C7.23305 0.400124 6.11389 0.863693 5.28873 1.68885L8.11716 4.51728ZM8.4 4.40012H15.6V0.400124H8.4V4.40012ZM15.6 4.40012C15.7061 4.40012 15.8078 4.44227 15.8828 4.51728L18.7113 1.68885C17.8861 0.863694 16.767 0.400124 15.6 0.400124V4.40012ZM15.8828 4.51728C15.9579 4.5923 16 4.69404 16 4.80012H20C20 3.63317 19.5364 2.51401 18.7113 1.68885L15.8828 4.51728ZM16 4.80012V21.6001H20V4.80012H16ZM18.8944 19.8113L12.8944 16.8113L11.1056 20.389L17.1056 23.389L18.8944 19.8113ZM11.1056 16.8113L5.10557 19.8113L6.89443 23.389L12.8944 20.389L11.1056 16.8113ZM8 21.6001V4.80012H4V21.6001H8Z",
    fill: "#1D39C4",
    mask: "url(#path-1-outside-1_6022_419)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6022_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.6f07d817655202553e5b29c490c19ce1.svg";
export { ForwardRef as ReactComponent };